export enum JsonContentEnum {
    EMPTY, VALID, DEFAULT, QA
}
